// extracted by mini-css-extract-plugin
module.exports = {"excel":"styles_excel__2l2BT","fileName":"styles_fileName__2yb8g","container":"styles_container__1DPYQ"};